import React, {Dispatch, SetStateAction} from 'react';
import s from "../../pages/PersonalAccount/Security/Security.module.css";
import style from "./HistoryTable.module.css"
import {ConfigProvider} from "antd";
import TransparentButton from "../ui/TransparentButton/TransparentButton";
import Icon from "@ant-design/icons";
import {ReactComponent as Back} from "../../assets/img/personalAccount/back.svg";
import Table, {ColumnsType} from "antd/es/table";
import {loginHistoryItem} from "../../types/interfaces";
import {ReactComponent as ArrowTop} from '../../assets/img/personalAccount/arrow_top.svg'
import {ReactComponent as ArrowDown} from '../../assets/img/personalAccount/arrow_down.svg'
import classnames from "classnames";
import {toHumanDateInLocalTimezone} from "../../helpers/ConvertDate";
import {useAppDispatch} from "../../store/store";
import {useAppSelector} from "../../hooks/redux";
import {
    getLoginHistoryThunk,
    LogoutThunk,
    setTokenState
} from "../../store/reducers/ActionCreators";
import {calculateCurrentDate} from "../../helpers/CalculateDate";

interface DataType {
    sessionStartForSorting: string;
    sessionStart: string;
    key: string;
    date: JSX.Element;
}

const columns: ColumnsType<DataType> = [
    {
        title: 'Session Start',
        dataIndex: 'sessionStart',
        sorter: (a, b) => {
            return new Date(a.sessionStartForSorting).getTime() - new Date(b.sessionStartForSorting).getTime()
        },
        sortDirections: ['ascend', 'descend'],
        sortIcon: ({ sortOrder }) => {
            if (sortOrder === 'ascend') {
                return <div className={s.arrows_wrapper}>
                    <Icon className={classnames(s.sort_icon_active, s.arrow_top)} component={() => <ArrowTop/>} rev={undefined}/>
                    <Icon className={classnames(s.arrow_down)} component={() => <ArrowDown/>} rev={undefined}/>
                </div>;
            }
            if (sortOrder === 'descend') {
                return <div className={s.arrows_wrapper}>
                    <Icon className={classnames(s.arrow_top)} component={() => <ArrowTop/>} rev={undefined}/>
                    <Icon className={classnames(s.sort_icon_active, s.arrow_down)} component={() => <ArrowDown/>} rev={undefined}/>
                </div>;
            }
            return <div className={s.arrows_wrapper}>
                <Icon className={classnames(s.arrow_top)} component={() => <ArrowTop/>} rev={undefined}/>
                <Icon className={classnames(s.arrow_down)} component={() => <ArrowDown/>} rev={undefined}/>
            </div>;
        },
    },
    {
        title: 'IP Address',
        dataIndex: 'IPAddress',
    },
    {
        title: 'Session End',
        dataIndex: 'sessionEnd',
    },
    {
        title: 'Duration',
        dataIndex: 'duration',
    },
];

type loginHistoryType = {
    loginHistory: loginHistoryItem[],
    currentPage: number,
    numberOfPages: number
}

type historyPropsType = {
    setIsHistoryShow: Dispatch<SetStateAction<boolean>>
    loginHistory: loginHistoryType
    isMobile: boolean
}

const HistoryTable = (props: historyPropsType) => {

    const dispatch = useAppDispatch()
    const userToken = useAppSelector(state => state.userReducer.userToken)
    const sessionId = useAppSelector(store => store.userReducer.sessionId)

    const handlePageChange = (page: number) => {

        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

        dispatch(getLoginHistoryThunk(userToken, calculateCurrentDate(), page))
            .then((res) => {
                console.log(res)
            })
            .catch((e) => {
                console.log(e)
                if (e.response.data === "Error: Conflict") {
                    dispatch(setTokenState(false))
                    dispatch(LogoutThunk(sessionId, timezone, userToken))
                }
            })
    }

    const tableData: Array<any> = props.loginHistory.loginHistory.map((item: loginHistoryItem) => {

        const sessionStart = toHumanDateInLocalTimezone(item.sessionStart)
        const sessionEnd = toHumanDateInLocalTimezone(item.sessionEnd)

        return {
            sessionStart: sessionStart,
            sessionStartForSorting: item.sessionStart,
            IPAddress: item.ipAddress,
            sessionEnd: sessionEnd,
            sessionEndForSorting: item.sessionEnd,
            duration: item.duration,
        }
    })

    const totalPages = props.loginHistory.numberOfPages
    const currentPage = props.loginHistory.currentPage

    return (
        <>
            {
                props.isMobile
                    ? <div>
                        {
                            props.loginHistory.loginHistory.length > 0
                                ? props.loginHistory.loginHistory.map((item: loginHistoryItem, index) => {
                                    return <div key={index} className={style.history_block}>
                                        {index === 0 && <h4 className={style.page_title}>Login History</h4>}

                                        <div className={style.history_block_row}>
                                            <div className={style.value_block}>
                                                <p className={style.value_label}>Session Start</p>
                                                <p className={style.value}>{item.sessionStart}</p>
                                            </div>
                                            <div className={style.value_block}>
                                                <p className={style.value_label}>Session End</p>
                                                <p className={style.value}>{item.sessionEnd}</p>
                                            </div>
                                        </div>
                                        <div className={style.history_block_row}>
                                            <div className={style.value_block}>
                                                <p className={style.value_label}>IP Address №</p>
                                                <p className={style.value}>{item.ipAddress}</p>
                                            </div>
                                            <div className={style.value_block}>
                                                <p className={style.value_label}>Duration</p>
                                                <p className={style.value}>{item.duration}</p>
                                            </div>
                                        </div>

                                    </div>
                                })
                                : <h4 className={style.page_title}>Login history is empty</h4>
                        }
                    </div>
                    : <div className={s.tableWrapper}>
                        <div className={s.table_title}>
                            Login History
                        </div>
                        <ConfigProvider theme={{
                            components: {
                                Pagination: {
                                    colorPrimary: '#FFFFFF',
                                    colorPrimaryHover: '#FFFFFF',
                                    colorBgContainer: '#4DB887',
                                    colorLink: '#FFFFFF'
                                },
                            },
                        }}>
                            <Table
                                bordered={false}
                                style={{marginTop: 32  }}
                                rowClassName={(record, index) => index % 2 !== 0 ? `${s.table_row_dark}` : ''}
                                className={s.statementTable}
                                columns={columns}
                                pagination={{
                                    position: ['bottomCenter'],
                                    defaultPageSize: 15,
                                    onChange: handlePageChange,
                                    total: totalPages * 15,
                                    current: currentPage
                                }}
                                dataSource={tableData}
                            />
                        </ConfigProvider>
                        <div className={s.button_wrapper}>
                            <TransparentButton
                                title={"Back"}
                                isPersonalAccountBtn
                                large
                                icon={<Icon component={() => <Back/>} rev={undefined}/>}
                                onClick={() => props.setIsHistoryShow(false)}
                            />
                        </div>
                    </div>
            }
        </>
    );
};

export default HistoryTable;
